import { ExpandMore, HelpOutline } from "@mui/icons-material"
import { Accordion, AccordionDetails, AccordionSummary, Checkbox, Tooltip, Typography } from "@mui/material"


export const SideList = ({entities, selectedTo, handleSelect, side, rightList, handleSelectAll}) => {

  const isDisabledInitEntity = (name) => {
    return side === 'left' && rightList?.length === 0 && selectedTo.length > 0 && !selectedTo?.some(item => 
      item.name === name ||
      item?.columns?.some(column => 
        column.relation_name === name || column.target_entity_inter === name
      )
    )
  }
  const isDisabledInProcessEntity = (name) => {
    let res = side === 'left' && rightList?.length > 0 && !selectedTo?.some(item => 
      item.name === name  ||
      item?.columns?.some(column => 
        column.relation_name === name || column.target_entity_inter === name
      )
    ) &&
    !rightList?.some(item => 
      item.name === name ||
      item?.columns?.some(column => 
        column?.relation_name === name || column?.target_entity_inter === name
      )
    )
    return res;
  }
  const checkEntity = (name, alias) => {
    let ent_sel = selectedTo.find(ent => ent.name === name && ent.alias === alias);
    let ent_org = entities.find(ent => ent.name === name && ent.alias === alias);
    if(ent_org && ent_sel){
      return ent_sel.columns.length === ent_org.columns.length;
    }else{
      return false;
    }
  }

  const isDisabledInit = (col) => {
    return side === 'left' && rightList?.length === 0 && selectedTo.length > 0 && !selectedTo?.some(item => 
      item.name === col.main_entity ||
      item?.columns?.some(column => 
        column.relation_name === col.main_entity || column.target_entity_inter === col.main_entity
      )
    )
  }
  const isDisabledInProcess = (col) => {
    let res = side === 'left' && rightList?.length > 0 && !selectedTo?.some(item => 
      item.name === col.main_entity ||
      item?.columns?.some(column => 
        column?.relation_name === col?.main_entity || column?.target_entity_inter === col?.main_entity
      )
    ) &&
    !rightList?.some(item => 
      item.name === col?.main_entity ||
      item?.columns?.some(column => 
        column?.relation_name === col?.main_entity || column?.target_entity_inter === col?.main_entity
      )
    )
    return res;
  }
  const checked_item = (entity, col) => {
    let isCheck = false;
    let entity_exist = selectedTo?.find(
      item => item?.name === entity?.name && item?.alias === entity?.alias
    )
    if(entity_exist){
      isCheck = entity_exist.columns?.some(
        item=>item?.name === col?.name
      )
    }
    return isCheck;
  }

  const chooseTitle = (col) => {
    if(col.target_entity_inter) return col.target_entity_inter
    if(!col.target_entity_inter && (col.relation_name === col.name) ) return col.name
    if(!col.target_entity_inter && col.relation_name && (col.relation_name !== col.name) ) return `${col.relation_name} (${col.name})`
    return col.name
  }
  const chooseName = (ent) => {
    if(ent?.alias){
      return `${ent.name} (${ent.alias})`
    }else{
      return `${ent.name}`
    }
  }

  return(
    <div key={`${side}_div`} style={{width: '100%', height:'78vh', overflow:'auto', padding:'5px'}}>
      {entities?.map((entity) => (
        <Accordion key={`${entity?.name}_${side}_${entity?.alias ? entity.alias : 'not_alias'}`}>
          <AccordionSummary expandIcon={<ExpandMore />} sx={{display:'flex', alignItems: 'center', justifyContent: 'flex-start', width:'auto'}} className="accordion-summary_entity">
            <Checkbox
              key={`${entity?.name}_${side}_check_${entity?.alias ? entity.alias : 'not_alias'}`}
              disabled={(isDisabledInitEntity(entity?.name) ||  isDisabledInProcessEntity(entity?.name))}
              onChange={(e) => handleSelectAll(side, entity)}
              checked = {checkEntity(entity?.name, entity?.alias)}
            />
            <Typography sx={{display:'flex', alignItems: 'center', mr:'12px'}}>{chooseName(entity)}</Typography>
            <Tooltip 
              key={`${entity?.name}_${side}_${entity?.alias ? entity.alias : 'not_alias'}_tooltip_help`} 
              title={entity?.description}
              placement="right" 
              arrow
            >
              <HelpOutline 
                key={`${entity?.name}_${side}_${entity?.alias ? entity.alias : 'not_alias'}_icon_help`}
                sx={{color:'#575E3B'}}
              />
            </Tooltip>
          </AccordionSummary>
          <AccordionDetails key={`${entity}_cols_${entity?.alias ? entity?.alias : 'not_alias'}_${entity?.columns?.length}`}>
            {entity?.columns?.map((col) => (
              <div key={`${col?.name}${entity?.alias ? entity.alias : 'not_alias'}`} style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                <Checkbox
                  key={`${col.name}_${side}_check_${entity?.alias ? entity.alias : 'not_alias'}`}
                  disabled={ (isDisabledInit(col) ||  isDisabledInProcess(col))}
                  checked={checked_item(entity, col)}
                  onChange={() => handleSelect(side, col, entity?.alias)}
                />
                <Typography key={`${col?.name}_${side}_check_title_${entity?.alias ? entity?.alias : 'not_alias'}`}>{chooseTitle(col)}</Typography>
              </div>
            ))}
          </AccordionDetails>
        </Accordion>
      ))}
    </div>
  )
}